import React from "react";
import { Trans, useTranslation } from "react-i18next";

import { useFormikContext } from "formik";

import {
  HvGlobalActions,
  HvTypography,
  HvGrid,
  HvEmptyState,
  useScrollTo,
} from "@hitachivantara/uikit-react-core";
import { Info } from "@hitachivantara/uikit-react-icons";

import { useEventType } from "lib/api";
import { WorkflowQueryBuilder } from "components/workflow/QueryBuilder";

import useStyles from "./styles";

const Conditions: React.FC = () => {
  const { t } = useTranslation("workflowAddEdit");

  // front load the query builder i18n files
  // so it won't mess with suspense later
  useTranslation("queryBuilder");
  useTranslation("selectLocationDialog");

  const classes = useStyles();

  const { values, touched, setFieldValue } =
    useFormikContext<WorkflowFormData>();

  const { eventTypeId, conditions } = values;
  const { data: eventType } = useEventType(eventTypeId, {
    revalidateOnFocus: false,
    suspense: !touched.eventTypeId,
  });

  const [, setScrollTo] = useScrollTo(
    0,
    "wis-container",
    false,
    100,
    [
      {
        value: "event-type",
      },
    ],
    undefined
  );

  return (
    <HvGrid container className={classes.root}>
      <HvGrid item xs={12}>
        <HvGlobalActions title={t("conditions.title")} variant="section" />
        <HvTypography variant="normalText">
          {t("conditions.description")}
        </HvTypography>
      </HvGrid>
      <HvGrid item xs={12} style={{ position: "relative" }}>
        {eventTypeId != null && eventTypeId !== "" ? (
          <WorkflowQueryBuilder
            value={conditions}
            setFieldValue={setFieldValue}
            loading={eventType == null}
            attributes={eventType?.data?.attributes}
            marker={eventType?.data?.appearance}
          />
        ) : (
          <HvEmptyState
            className={classes.noEventType}
            title={t("conditions.emptyState.titleNoEventType")}
            message={
              <Trans
                t={t}
                i18nKey="conditions.emptyState.messageNoEventType"
                components={[
                  <HvTypography
                    variant="link"
                    component="a"
                    onClick={() => {
                      setScrollTo(null, "event-type", 0, undefined);
                    }}
                    className={classes.link}
                  />,
                ]}
              />
            }
            icon={<Info />}
          />
        )}
      </HvGrid>
    </HvGrid>
  );
};

export default Conditions;
